import { Head, usePoll } from '@inertiajs/react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import FdeShell from '@/frontend/features/Fde/FdeShell'
import ProjectTaskDetail from '@/frontend/features/Fde/ProjectTaskDetail'
import type { ProjectTaskPageProps } from '@/frontend/features/Fde/types'

function TaskPage(props: ProjectTaskPageProps) {
  usePoll(
    30_000,
    { only: ['task', 'task_assignees', 'task_context', 'task_link_options'] },
    { autoStart: Boolean(props.task && props.project) },
  )
  return (
    <>
      <Head title={props.page_title} />
      <FdeShell
        copy={props.copy}
        eyebrow=""
        title={props.project?.name ?? props.organization.name}
        description=""
        projectId={props.project?.id}
      >
        <ProjectTaskDetail
          key={`${props.project!.id}:${props.task?.id ?? 'new'}:${props.task_defaults?.parent_task_id ?? ''}`}
          projectId={props.project!.id}
          task={props.task}
          defaults={props.task_defaults}
          assignees={props.task_assignees}
          context={props.task_context}
          linkOptions={props.task_link_options}
          canManage={props.can_manage}
          copy={props.copy}
        />
      </FdeShell>
    </>
  )
}

TaskPage.layout = (page: React.ReactElement) => (
  <DashboardLayout variant="canvas">{page}</DashboardLayout>
)
export default TaskPage
